import { ReactNode } from "react";

const Container: React.FC<{
  children: ReactNode;
  isVendor?: boolean;
  className?: string;
}> = ({ children, isVendor, className = "" }) => (
  <div
    className={`flex min-h-screen flex-col ${isVendor ? "" : "md:flex-row"} ${className}`}
  >
    {children}
  </div>
);

export default Container;
